import gql from "graphql-tag";

import { Fragment, Credential } from "../types";

export const CREDENTIAL_FRAGMENT = gql`
  fragment CredentialFragment on Credential {
    accessToken
    uid
    tokenType
    client
    expiry
  }
`;

export type CredentialFragment = Fragment<Credential, Credential>;
